import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastMessagesService {

  constructor(private messageService: MessageService) { }

  showSuccessMessage(summary: string, detail: string, sticky:boolean = false, key?:string | undefined): void {
    this.messageService.add({
      severity: 'success',
      summary,
      detail,
      sticky,
      key
    });
  }

  showErrorMessage(summary: string, detail: string, sticky:boolean = false): void {
    this.messageService.add({
      severity: 'error',
      summary,
      detail,
      sticky
    });
  }

  /** Generic "operation failed" toast for a create/update submit error — but only when nothing
   *  has already told the user why. The HTTP interceptor stamps `llqHandled = true` on any error
   *  it already surfaced itself (plan-limit dialog, access-denied dialog, subscription-expired
   *  redirect, etc. — see tallysheet-http.interceptor.ts's handleError()); showing a second,
   *  vaguer "Operation failed" toast on top of that is exactly what buried the real "Plan Limit
   *  Reached" message on the Stock Unit create form (found 2026-08-19). Call this instead of a
   *  bare showErrorMessage() from any component's HTTP error callback. */
  showHttpErrorMessage(err: unknown, fallbackDetail: string, summary: string = 'Error'): void {
    if ((err as any)?.llqHandled) return;
    const httpError = err as { error?: { message?: string; error?: string } } | null;
    const detail = httpError?.error?.message || httpError?.error?.error || fallbackDetail;
    this.showErrorMessage(summary, detail);
  }

  showWarningMessage(summary: string, detail: string, sticky:boolean = false): void {
    this.messageService.add({
      severity: 'warn',
      summary,
      detail,
      sticky
    });
  }

  showInfoMessage(summary: string, detail: string, sticky:boolean = false): void {
    this.messageService.add({
      severity: 'info',
      summary,
      detail,
      sticky
    });
  }

  clearMessage(){
    this.messageService.clear();
  }
}
